/**
 * Configuration pour l'auto-souscription aux notifications push
 */
export const PUSH_AUTO_SUBSCRIBE_CONFIG = {
  // Activer/désactiver l'auto-souscription globalement
  enabled: true,

  // Demander la permission lors de la première connexion
  requestPermissionOnFirstLogin: true,

  // Afficher la modale lors de la première connexion
  showModalOnFirstLogin: true,

  // Souscrire automatiquement si la permission est déjà accordée
  silentSubscribeIfGranted: true,

  // Se désabonner lors de la déconnexion (false pour garder les notifications)
  unsubscribeOnLogout: false,

  // Réessayer en cas d'échec
  retryOnFailure: true,

  // Délai avant de réessayer (en millisecondes)
  retryDelay: 5000,

  // Afficher des logs de debug
  debug: process.env.NODE_ENV === 'development'
};

/**
 * Configuration pour différents environnements
 */
export const getAutoSubscribeConfig = (environment = 'production') => {
  const baseConfig = { ...PUSH_AUTO_SUBSCRIBE_CONFIG };

  switch (environment) {
    case 'development':
      return {
        ...baseConfig,
        debug: true,
        retryDelay: 2000 // Plus rapide en dev
      };

    case 'production':
      return {
        ...baseConfig,
        debug: false,
        retryDelay: 5000
      };

    case 'test':
      return {
        ...baseConfig,
        enabled: false // Désactiver en test par défaut
      };

    default:
      return baseConfig;
  }
};
